module.exports = __webpack_public_path__ + "assets/d0894f1f934de93092d9fe020d909d35.mp3";